import { useToastContext } from 'context/ToastContext'

function useToasts() {
  const { addToast } = useToastContext()

  return { addToast }
}

export default useToasts
